import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-right-gray.svg'


const _hoisted_1 = { class: "flex flex-row w-full items-center" }
const _hoisted_2 = { class: "font-semibold flex ml-4" }
const _hoisted_3 = { class: "font-normal text-gray-lp-500" }
const _hoisted_4 = { class: "w-full font-normal text-black-lp-300 flex flex-row capitalize" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 max-w-none mx-3",
  alt: "arrow-right"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "w-full font-normal text-black-lp-300 flex flex-row capitalize"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center ellipsis-2 mt-1 absolute bottom-0 right-0"
}
const _hoisted_8 = {
  class: "bg-red-lp-100 text-white text-10px px-1 rounded-tl flex justify-center items-center gap-1",
  style: {"padding-top":"1px","padding-bottom":"1px"}
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Direkomendasikan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", {
    class: ["px-6 py-4 pr-8 items-center grid grid-cols-3 gap-4 cursor-pointer border  rounded-lg relative", 
      `${_ctx.isActive ? 'border-red-lp-1500 bg-red-lp-50' : 'border-gray-lp-400'}`
    ],
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Icons, {
        name: _ctx.icon,
        class: "w-6 text-gray-lp-600"
      }, null, 8, ["name"]),
      _createVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.type) + " ", 1),
        _createVNode("span", _hoisted_3, "  (" + _toDisplayString(_ctx.$t(_ctx.isManual ? "Booking manual" : "Booking auto" )) + ") ", 1)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.origin) + " ", 1),
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.destination), 1)
    ]),
    (_ctx.isManual && !_ctx.isRecommended)
      ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.defaultRangeToday), 1))
      : _createCommentVNode("", true),
    (_ctx.isRecommended)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Icons, {
              name: "star",
              class: "w-3"
            }),
            _hoisted_9
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}